import UsersTable from 'components/Settings/User';
import PermissionGuard from 'components/Global/PermissionGuard'; 
export const Users = () => {
	return (
		<PermissionGuard permission="Allow_Users">
			<UsersTable />
		</PermissionGuard>
	);
};
